/* unplugin-vue-components disabled */import { render } from "./DefaultTemplateRenderer.vue?vue&type=template&id=435315cd"
import script from "./DefaultTemplateRenderer.vue?vue&type=script&lang=js"
export * from "./DefaultTemplateRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__